<template>
  <!-- Статус словом и цветом (11-acceptance «Страница «Обращения филиала»») -->
  <span class="status-text">
    <v-icon v-if="view.tone === 'idea'" size="16" class="status-text__idea-icon">
      mdi-lightbulb-outline
    </v-icon>
    <span class="status-text__label" :class="`status-text__label--${view.tone}`">{{ view.label }}</span>
    <template v-if="view.extra">
      <span class="status-text__dot">·</span>
      <span class="status-text__extra">{{ view.extra }}</span>
      <!-- Бежевый кружок с залитой звездой: ждём оценку -->
      <span class="status-text__star">
        <v-icon size="12">mdi-star</v-icon>
      </span>
    </template>
  </span>
</template>

<script>
  import { statusView } from './status'

  export default {
    name: 'AppealStatusText',
    props: {
      appeal: { type: Object, required: true },
    },
    computed: {
      view () {
        return statusView(this.appeal)
      },
    },
  }
</script>

<style scoped lang="less">
@import './tokens.less';

.status-text {
  display: inline-flex;
  gap: 6px;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
}

.status-text__label {
  &--new { color: @sup-new; }
  &--work { color: @sup-work; }
  &--wait { color: @sup-wait; }
  &--done { color: @sup-done; }
  &--muted { color: @fakt-text-2; }
  &--idea { color: @fakt-text-2; }
}

.status-text__idea-icon {
  color: @fakt-orange !important;
}

.status-text__dot {
  color: @fakt-text-3;
}

.status-text__extra {
  color: @fakt-pink;
}

.status-text__star {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: @sup-new-bg;

  .v-icon {
    color: @fakt-orange !important;
  }
}
</style>
